<template>
    <!-- Price Section start-->
  <v-container ref="pricingcontainer" fluid class="pricing-container">
    <price :basicCost="basicCost" :premiumCost="premiumCost" :premiumCorpCost="premiumCorpCost" :subscriptionCost="subscriptionCost" :corpCost="corpCost" :translateCost="translateCost" @buy-basic="onBuyBasic" @buy-premium="onBuyPremium" @buy-corp="onBuyCorp"></price>
  </v-container>
</template>

<script>
import Price from '../components/pricing/Price'
import textHelper from "@/utils/textManager";

export default {
  name: 'PricingSection',
  components:{Price},
  metaInfo() {
    const me = this;
    return{
      title: me.$lang.price.choose_plan,//me.$lang.about.taption,
      titleTemplate: '%s - Taption',

      meta: [
        { vmid: 'name', content: me.$lang.price.choose_plan, itemprop: 'name' },
        { vmid: 'description', content: me.$lang.price.annually_save.replace('{0}','10'), itemprop: 'description' },
        { vmid: 'article_desc', content: me.$lang.price.annually_save.replace('{0}','10'), name: 'description' },
        { vmid: 'og_title', content: me.$lang.price.choose_plan, property: 'og:title' },
        { vmid: 'og_desc', content: me.$lang.price.annually_save.replace('{0}','10'), property: 'og:description' },
        { vmid:'twitter_title', content: me.$lang.price.choose_plan, name: 'twitter:title' },
        { vmid:'twitter_desc',content: me.$lang.price.annually_save.replace('{0}','10'), name: 'twitter:description' },
      ]
    }
  },
  data () {
    return {
        basicCost:8,
        premiumCost:6,
        premiumCorpCost:4,
        subscriptionCost:12,
        corpCost:69,
        translateCost: 2
    }
  },
  methods: {
    onBuyBasic () {
      window.location.href = textHelper.getAppLoginUrl('buybasic');
    },
    onBuyPremium () {
      window.location.href = textHelper.getAppLoginUrl('buypremium');
    },
    onBuyCorp(){
      window.location.href = textHelper.getAppLoginUrl('buycorp');
    }
  },
  mounted () {
    const me = this;

    setTimeout(function() {
      me.$refs.pricingcontainer.classList.add("show");
    }, 100);
    window.scrollTo(0, 0);
  }
}
</script>

<style>
.pricing-container .price{
    margin-top: 100px;
}

@media only screen and (max-device-width: 600px) {

.price a.contact-us{
  position:relative!important;
  right:auto!important;
  bottom:auto!important;
}
}


</style>

<style scoped>

.logo {
  position: absolute;
  top: 50px;
  left: 120px;
}


.pricing-container .cards-container,
.pricing-container{
    max-width: 100%;
    margin-top:50px;
}

.pricing-container{
  -webkit-transition: all 200ms ease-in;
  -moz-transition: all 200ms ease-in;
  -o-transition: all 200ms ease-in;
  transition: all 200ms ease-in;
  opacity: 0;
}

.pricing-container.show {
  opacity: 1 !important;
}
</style>


